/**
 * Generated by orval v8.8.1 🍺
 * Do not edit manually.
 * Users API
 * API for managing users
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

/**
 * @summary Issue temporary password by email (internal pseudo request)
 */
export const issueTemporaryPasswordByEmailBodyEmailMax = 255;

export const IssueTemporaryPasswordByEmailBody = zod
    .object({
        email: zod.string().email().max(issueTemporaryPasswordByEmailBodyEmailMax).describe("Target email address"),
    })
    .strict();

export const IssueTemporaryPasswordByEmail200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        user_found: zod.boolean(),
        user_id: zod.number().optional(),
        temporary_password: zod.string().nullish(),
        expires_at: zod.string().datetime({ offset: true }).optional(),
    })
    .strict();

export const IssueTemporaryPasswordByEmail400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * @summary Check whether user exists by email (internal pseudo request)
 */
export const existsUserByEmailQueryEmailMax = 255;

export const ExistsUserByEmailQueryParams = zod
    .object({
        email: zod.string().email().max(existsUserByEmailQueryEmailMax).describe("Target email address"),
    })
    .strict();

export const ExistsUserByEmail200Response = zod
    .object({
        exists: zod.boolean(),
    })
    .strict();

export const ExistsUserByEmail400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * @summary Update user password
 */
export const UpdatePasswordParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const updatePasswordBodyPasswordMin = 8;
export const updatePasswordBodyPasswordMax = 100;

export const updatePasswordBodyPasswordConfirmationMin = 8;

export const UpdatePasswordBody = zod
    .object({
        current_password: zod
            .string()
            .nullish()
            .describe("Optional current password. When provided, it is verified against the authenticated user."),
        password: zod
            .string()
            .min(updatePasswordBodyPasswordMin)
            .max(updatePasswordBodyPasswordMax)
            .describe("New password (at least 8 characters)."),
        password_confirmation: zod
            .string()
            .min(updatePasswordBodyPasswordConfirmationMin)
            .describe("Must match password."),
    })
    .strict();

export const UpdatePassword200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpdatePassword401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const UpdatePassword403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const UpdatePassword422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const UpdatePassword500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

/**
 * For platforms where a real HTTP existence check has proven reliable (x, youtube, website), performs a live HTTP request. For platforms that return the same response regardless of existence when probed server-side (instagram, tiktok, facebook), falls back to a format-only check and never makes an outbound request for those.
 * @summary Check whether an SNS handle/URL looks valid or reachable
 */
export const checkSocialHandleBodyValueMax = 100;

export const CheckSocialHandleBody = zod
    .object({
        platform: zod.enum(["instagram", "tiktok", "facebook", "x", "youtube", "website"]),
        value: zod
            .string()
            .min(1)
            .max(checkSocialHandleBodyValueMax)
            .describe("Username, handle, or full profile\/website URL as typed by the user."),
    })
    .strict();

export const CheckSocialHandle200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                exists: zod
                    .boolean()
                    .optional()
                    .describe(
                        "true if the HTTP check found the profile (method=http), or the value passed format validation (method=format).",
                    ),
                method: zod.enum(["http", "format"]).optional(),
                checked_url: zod.string().nullish(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CheckSocialHandle401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const CheckSocialHandle422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get paginated list of users with search and filtering
 */
export const getItemsQuerySearchMax = 100;

export const getItemsQueryIncludeDummyDefault = false;
export const getItemsQueryPageDefault = 1;

export const getItemsQueryPerPageDefault = 100;
export const getItemsQueryPerPageMax = 100;

export const getItemsQuerySortDefault = `user_id`;
export const getItemsQueryOrderDefault = `asc`;

export const GetItemsQueryParams = zod
    .object({
        search: zod.string().max(getItemsQuerySearchMax).optional().describe("Search keyword for user name or email"),
        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional().describe("Filter by user role"),
        status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional().describe("Filter by user status"),
        include_dummy: zod
            .boolean()
            .default(getItemsQueryIncludeDummyDefault)
            .describe("Include user_status=dummy users in the listing (admin\/editor only). Defaults to false."),
        page: zod.number().min(1).default(getItemsQueryPageDefault).describe("Page number for pagination"),
        per_page: zod
            .number()
            .min(1)
            .max(getItemsQueryPerPageMax)
            .default(getItemsQueryPerPageDefault)
            .describe("Number of items per page"),
        sort: zod
            .enum(["user_id", "full_name", "email", "role", "status", "created_at", "updated_at"])
            .default(getItemsQuerySortDefault)
            .describe("Sort field"),
        order: zod.enum(["asc", "desc"]).default(getItemsQueryOrderDefault).describe("Sort order"),
    })
    .strict();

export const getItems200ResponseDataItemDisplayNameMax = 50;

export const getItems200ResponseDataItemFullNameMax = 150;

export const getItems200ResponseDataItemFirstNameMax = 100;

export const getItems200ResponseDataItemMiddleNameMax = 50;

export const getItems200ResponseDataItemLastNameMax = 100;

export const getItems200ResponseDataItemNickNameMax = 50;

export const getItems200ResponseDataItemEmailMax = 255;

export const getItems200ResponseDataItemPreferredPriceRangeMax = 50;

export const getItems200ResponseDataItemPrefectureMax = 100;

export const getItems200ResponseDataItemAddressMax = 255;

export const getItems200ResponseDataItemCityMax = 100;

export const getItems200ResponseDataItemZipCodeMax = 10;

export const getItems200ResponseDataItemPhoneMax = 20;

export const getItems200ResponseDataItemAvatarMax = 255;

export const getItems200ResponseDataItemUserNoteMax = 1000;

export const getItems200ResponseDataItemSocialInstagramMax = 100;

export const getItems200ResponseDataItemSocialFacebookMax = 100;

export const getItems200ResponseDataItemSocialXMax = 100;

export const getItems200ResponseDataItemSocialTiktokMax = 100;

export const getItems200ResponseDataItemSocialYoutubeMax = 100;

export const getItems200ResponseDataItemSocialWebsiteMax = 500;

export const GetItems200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        data: zod
            .array(
                zod
                    .object({
                        user_id: zod.number().optional(),
                        display_name: zod
                            .string()
                            .max(getItems200ResponseDataItemDisplayNameMax)
                            .optional()
                            .describe("Full display name"),
                        full_name: zod
                            .string()
                            .max(getItems200ResponseDataItemFullNameMax)
                            .optional()
                            .describe("Full name"),
                        first_name: zod
                            .string()
                            .max(getItems200ResponseDataItemFirstNameMax)
                            .optional()
                            .describe("First name"),
                        middle_name: zod
                            .string()
                            .max(getItems200ResponseDataItemMiddleNameMax)
                            .optional()
                            .describe("Middle name (optional)"),
                        last_name: zod
                            .string()
                            .max(getItems200ResponseDataItemLastNameMax)
                            .optional()
                            .describe("Last name"),
                        nick_name: zod
                            .string()
                            .max(getItems200ResponseDataItemNickNameMax)
                            .optional()
                            .describe("Nickname or username"),
                        email: zod.string().email().max(getItems200ResponseDataItemEmailMax).optional(),
                        date_of_birth: zod.string().date().nullish().describe("Date of birth in YYYY-MM-DD format"),
                        gender: zod
                            .enum(["male", "female", "other", "prefer_not_to_say"])
                            .nullish()
                            .describe("Gender identity"),
                        skin_type: zod
                            .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
                            .nullish()
                            .describe("Skin type (preference profile)"),
                        skin_concerns: zod
                            .array(zod.string())
                            .optional()
                            .describe("Skin concerns (multiple selection)"),
                        skin_tone: zod
                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                            .nullish()
                            .describe("Skin tone (single select)"),
                        hair_type: zod
                            .enum([
                                "straight_coarse",
                                "straight_soft",
                                "wavy_coarse",
                                "wavy_soft",
                                "normal_hair",
                                "not_sure",
                            ])
                            .nullish()
                            .describe("Hair type (single select)"),
                        hair_scalp_concerns: zod.array(zod.string()).optional().describe("Hair and scalp concerns"),
                        beauty_wellness_interests: zod
                            .array(zod.string())
                            .optional()
                            .describe("Beauty and wellness interests"),
                        lifestyle_environment: zod
                            .array(zod.string())
                            .optional()
                            .describe("Lifestyle and environment selections"),
                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                        preferred_price_range: zod
                            .string()
                            .max(getItems200ResponseDataItemPreferredPriceRangeMax)
                            .optional(),
                        frequent_category_ids: zod
                            .array(zod.number())
                            .optional()
                            .describe("Frequently used category IDs"),
                        frequent_brand_ids: zod.array(zod.number()).optional().describe("Frequently used brand IDs"),
                        prefecture: zod
                            .string()
                            .max(getItems200ResponseDataItemPrefectureMax)
                            .optional()
                            .describe("Prefecture\/province label as stored in user profile"),
                        address: zod
                            .string()
                            .max(getItems200ResponseDataItemAddressMax)
                            .optional()
                            .describe("Full address (single field)"),
                        city: zod.string().max(getItems200ResponseDataItemCityMax).optional().describe("City"),
                        zip_code: zod
                            .string()
                            .max(getItems200ResponseDataItemZipCodeMax)
                            .optional()
                            .describe("Postal code"),
                        phone: zod
                            .string()
                            .max(getItems200ResponseDataItemPhoneMax)
                            .optional()
                            .describe("Phone number"),
                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                        avatar: zod
                            .string()
                            .max(getItems200ResponseDataItemAvatarMax)
                            .optional()
                            .describe("Avatar filename or external URL. Example: user_1_1734567890.jpg"),
                        user_status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional(),
                        user_note: zod
                            .string()
                            .max(getItems200ResponseDataItemUserNoteMax)
                            .optional()
                            .describe("Admin note. For user_status=migrated: the legacy email\/avatar."),
                        point: zod.number().optional().describe("User points or score"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        posts_count: zod.number().nullish().describe("Number of posts created by user (all boards)"),
                        review_count: zod
                            .number()
                            .nullish()
                            .describe("Number of review posts created by user (board_id=review)"),
                        followers_count: zod.number().optional().describe("Number of followers"),
                        followings_count: zod.number().optional().describe("Number of users being followed"),
                        followers: zod.array(zod.number()).optional().describe("List of follower user IDs"),
                        followings: zod.array(zod.number()).optional().describe("List of following user IDs"),
                        favorites: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                        favorite_products: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                        favorites_count: zod.number().optional().describe("Number of favorite products"),
                        social_instagram: zod
                            .string()
                            .max(getItems200ResponseDataItemSocialInstagramMax)
                            .optional()
                            .describe("Instagram username"),
                        social_facebook: zod
                            .string()
                            .max(getItems200ResponseDataItemSocialFacebookMax)
                            .optional()
                            .describe("Facebook username or profile URL"),
                        social_x: zod
                            .string()
                            .max(getItems200ResponseDataItemSocialXMax)
                            .optional()
                            .describe("X (Twitter) username"),
                        social_tiktok: zod
                            .string()
                            .max(getItems200ResponseDataItemSocialTiktokMax)
                            .optional()
                            .describe("TikTok username"),
                        social_youtube: zod
                            .string()
                            .max(getItems200ResponseDataItemSocialYoutubeMax)
                            .optional()
                            .describe("YouTube channel name or URL"),
                        social_website: zod
                            .string()
                            .max(getItems200ResponseDataItemSocialWebsiteMax)
                            .optional()
                            .describe("Personal or profile website URL"),
                        favorite_brands: zod.array(zod.string()).optional().describe("List of favorite brand names"),
                        created_by: zod.number().nullish().describe("User ID that created this user record"),
                        updated_by: zod.number().nullish().describe("User ID that last updated this user record"),
                        recommend_rank: zod.number().min(1).nullish().describe("Recommend ranking rank"),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                        last_login_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last login timestamp"),
                    })
                    .strict(),
            )
            .optional(),
        pagination: zod
            .object({
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                current_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetItems400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod.literal(400).describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Create a new user
 */
export const createItemBodyDisplayNameMax = 50;

export const createItemBodyFirstNameMax = 100;

export const createItemBodyMiddleNameMax = 50;

export const createItemBodyLastNameMax = 100;

export const createItemBodyNickNameMax = 50;

export const createItemBodyEmailMax = 255;

export const createItemBodyPreferredPriceRangeMax = 50;

export const createItemBodyPrefectureMax = 100;

export const createItemBodyAddressMax = 255;

export const createItemBodyCityMax = 100;

export const createItemBodyZipCodeMax = 10;

export const createItemBodyZipCodeRegExp = new RegExp("^\\d{5}$");
export const createItemBodyPhoneMax = 20;

export const createItemBodyAvatarMax = 255;

export const createItemBodyUserNoteMax = 1000;

export const CreateItemBody = zod
    .object({
        display_name: zod.string().max(createItemBodyDisplayNameMax).optional().describe("Full display name"),
        first_name: zod.string().max(createItemBodyFirstNameMax).optional().describe("First name"),
        middle_name: zod.string().max(createItemBodyMiddleNameMax).optional().describe("Middle name (optional)"),
        last_name: zod.string().max(createItemBodyLastNameMax).optional().describe("Last name"),
        nick_name: zod.string().max(createItemBodyNickNameMax).describe("Nickname or username"),
        email: zod.string().email().max(createItemBodyEmailMax),
        date_of_birth: zod.string().date().nullish().describe("Date of birth in YYYY-MM-DD format"),
        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).optional().describe("Gender identity"),
        skin_type: zod
            .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
            .optional()
            .describe("Skin type (preference profile)"),
        skin_concerns: zod
            .string()
            .nullish()
            .describe(
                "Skin concerns (multiple selection). Accepts comma-separated string or JSON array string; server normalizes to array.",
            ),
        skin_tone: zod
            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
            .optional()
            .describe("Skin tone (single select)"),
        hair_type: zod
            .enum(["straight_coarse", "straight_soft", "wavy_coarse", "wavy_soft", "normal_hair", "not_sure"])
            .optional()
            .describe("Hair type (single select)"),
        hair_scalp_concerns: zod
            .string()
            .nullish()
            .describe(
                "Hair & scalp concerns (multiple selection). Accepts comma-separated string or JSON array string; server normalizes to array.",
            ),
        beauty_wellness_interests: zod
            .string()
            .nullish()
            .describe(
                "Beauty & wellness interests (multiple selection). Accepts comma-separated string or JSON array string; server normalizes to array.",
            ),
        lifestyle_environment: zod
            .string()
            .nullish()
            .describe(
                "Lifestyle environment (multiple selection). Accepts comma-separated string or JSON array string; server normalizes to array.",
            ),
        makeup_frequency: zod
            .enum(["every_day", "occasionally", "rarely"])
            .optional()
            .describe("Makeup frequency (single select)"),
        preferred_price_range: zod
            .string()
            .max(createItemBodyPreferredPriceRangeMax)
            .optional()
            .describe("Preferred price range (single select)"),
        frequent_category_ids: zod
            .string()
            .nullish()
            .describe(
                "Frequently used category IDs. Accepts comma-separated string or JSON array string; server normalizes to int[].",
            ),
        frequent_brand_ids: zod
            .string()
            .nullish()
            .describe(
                "Frequently used brand IDs. Accepts comma-separated string or JSON array string; server normalizes to int[].",
            ),
        prefecture: zod
            .string()
            .max(createItemBodyPrefectureMax)
            .optional()
            .describe("Prefecture\/province label as stored in user profile"),
        address: zod.string().max(createItemBodyAddressMax).optional().describe("Physical address"),
        city: zod.string().max(createItemBodyCityMax).optional().describe("City"),
        zip_code: zod
            .string()
            .max(createItemBodyZipCodeMax)
            .regex(createItemBodyZipCodeRegExp)
            .optional()
            .describe("Postal code"),
        phone: zod.string().max(createItemBodyPhoneMax).describe("Phone number"),
        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
        avatar: zod
            .string()
            .max(createItemBodyAvatarMax)
            .optional()
            .describe("Avatar filename or external URL. Example: user_1_1734567890.jpg"),
        user_status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional(),
        user_note: zod
            .string()
            .max(createItemBodyUserNoteMax)
            .optional()
            .describe('Admin note. For user_status=migrated: the legacy email\/avatar (\"email:... avatar:...\").'),
        point: zod.number().nullish().describe("User points or score"),
        created_at: zod.string().datetime({ offset: true }).nullish(),
        updated_at: zod.string().datetime({ offset: true }).nullish(),
    })
    .strict();

export const createItem201ResponseItemDisplayNameMax = 50;

export const createItem201ResponseItemFullNameMax = 150;

export const createItem201ResponseItemFirstNameMax = 100;

export const createItem201ResponseItemMiddleNameMax = 50;

export const createItem201ResponseItemLastNameMax = 100;

export const createItem201ResponseItemNickNameMax = 50;

export const createItem201ResponseItemEmailMax = 255;

export const createItem201ResponseItemPreferredPriceRangeMax = 50;

export const createItem201ResponseItemPrefectureMax = 100;

export const createItem201ResponseItemAddressMax = 255;

export const createItem201ResponseItemCityMax = 100;

export const createItem201ResponseItemZipCodeMax = 10;

export const createItem201ResponseItemPhoneMax = 20;

export const createItem201ResponseItemAvatarMax = 255;

export const createItem201ResponseItemUserNoteMax = 1000;

export const createItem201ResponseItemSocialInstagramMax = 100;

export const createItem201ResponseItemSocialFacebookMax = 100;

export const createItem201ResponseItemSocialXMax = 100;

export const createItem201ResponseItemSocialTiktokMax = 100;

export const createItem201ResponseItemSocialYoutubeMax = 100;

export const createItem201ResponseItemSocialWebsiteMax = 500;

export const CreateItem201Response = zod
    .object({
        item: zod
            .object({
                user_id: zod.number().optional(),
                display_name: zod
                    .string()
                    .max(createItem201ResponseItemDisplayNameMax)
                    .optional()
                    .describe("Full display name"),
                full_name: zod.string().max(createItem201ResponseItemFullNameMax).optional().describe("Full name"),
                first_name: zod.string().max(createItem201ResponseItemFirstNameMax).optional().describe("First name"),
                middle_name: zod
                    .string()
                    .max(createItem201ResponseItemMiddleNameMax)
                    .optional()
                    .describe("Middle name (optional)"),
                last_name: zod.string().max(createItem201ResponseItemLastNameMax).optional().describe("Last name"),
                nick_name: zod
                    .string()
                    .max(createItem201ResponseItemNickNameMax)
                    .optional()
                    .describe("Nickname or username"),
                email: zod.string().email().max(createItem201ResponseItemEmailMax).optional(),
                date_of_birth: zod.string().date().nullish().describe("Date of birth in YYYY-MM-DD format"),
                gender: zod
                    .enum(["male", "female", "other", "prefer_not_to_say"])
                    .nullish()
                    .describe("Gender identity"),
                skin_type: zod
                    .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
                    .nullish()
                    .describe("Skin type (preference profile)"),
                skin_concerns: zod.array(zod.string()).optional().describe("Skin concerns (multiple selection)"),
                skin_tone: zod
                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                    .nullish()
                    .describe("Skin tone (single select)"),
                hair_type: zod
                    .enum(["straight_coarse", "straight_soft", "wavy_coarse", "wavy_soft", "normal_hair", "not_sure"])
                    .nullish()
                    .describe("Hair type (single select)"),
                hair_scalp_concerns: zod.array(zod.string()).optional().describe("Hair and scalp concerns"),
                beauty_wellness_interests: zod.array(zod.string()).optional().describe("Beauty and wellness interests"),
                lifestyle_environment: zod
                    .array(zod.string())
                    .optional()
                    .describe("Lifestyle and environment selections"),
                makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                preferred_price_range: zod.string().max(createItem201ResponseItemPreferredPriceRangeMax).optional(),
                frequent_category_ids: zod.array(zod.number()).optional().describe("Frequently used category IDs"),
                frequent_brand_ids: zod.array(zod.number()).optional().describe("Frequently used brand IDs"),
                prefecture: zod
                    .string()
                    .max(createItem201ResponseItemPrefectureMax)
                    .optional()
                    .describe("Prefecture\/province label as stored in user profile"),
                address: zod
                    .string()
                    .max(createItem201ResponseItemAddressMax)
                    .optional()
                    .describe("Full address (single field)"),
                city: zod.string().max(createItem201ResponseItemCityMax).optional().describe("City"),
                zip_code: zod.string().max(createItem201ResponseItemZipCodeMax).optional().describe("Postal code"),
                phone: zod.string().max(createItem201ResponseItemPhoneMax).optional().describe("Phone number"),
                role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                avatar: zod
                    .string()
                    .max(createItem201ResponseItemAvatarMax)
                    .optional()
                    .describe("Avatar filename or external URL. Example: user_1_1734567890.jpg"),
                user_status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional(),
                user_note: zod
                    .string()
                    .max(createItem201ResponseItemUserNoteMax)
                    .optional()
                    .describe("Admin note. For user_status=migrated: the legacy email\/avatar."),
                point: zod.number().optional().describe("User points or score"),
                monthly_rank: zod
                    .number()
                    .min(1)
                    .nullish()
                    .describe("Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)"),
                posts_count: zod.number().nullish().describe("Number of posts created by user (all boards)"),
                review_count: zod
                    .number()
                    .nullish()
                    .describe("Number of review posts created by user (board_id=review)"),
                followers_count: zod.number().optional().describe("Number of followers"),
                followings_count: zod.number().optional().describe("Number of users being followed"),
                followers: zod.array(zod.number()).optional().describe("List of follower user IDs"),
                followings: zod.array(zod.number()).optional().describe("List of following user IDs"),
                favorites: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                favorite_products: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                favorites_count: zod.number().optional().describe("Number of favorite products"),
                social_instagram: zod
                    .string()
                    .max(createItem201ResponseItemSocialInstagramMax)
                    .optional()
                    .describe("Instagram username"),
                social_facebook: zod
                    .string()
                    .max(createItem201ResponseItemSocialFacebookMax)
                    .optional()
                    .describe("Facebook username or profile URL"),
                social_x: zod
                    .string()
                    .max(createItem201ResponseItemSocialXMax)
                    .optional()
                    .describe("X (Twitter) username"),
                social_tiktok: zod
                    .string()
                    .max(createItem201ResponseItemSocialTiktokMax)
                    .optional()
                    .describe("TikTok username"),
                social_youtube: zod
                    .string()
                    .max(createItem201ResponseItemSocialYoutubeMax)
                    .optional()
                    .describe("YouTube channel name or URL"),
                social_website: zod
                    .string()
                    .max(createItem201ResponseItemSocialWebsiteMax)
                    .optional()
                    .describe("Personal or profile website URL"),
                favorite_brands: zod.array(zod.string()).optional().describe("List of favorite brand names"),
                created_by: zod.number().nullish().describe("User ID that created this user record"),
                updated_by: zod.number().nullish().describe("User ID that last updated this user record"),
                recommend_rank: zod.number().min(1).nullish().describe("Recommend ranking rank"),
                created_at: zod.string().datetime({ offset: true }).optional(),
                updated_at: zod.string().datetime({ offset: true }).optional(),
                last_login_at: zod.string().datetime({ offset: true }).optional().describe("Last login timestamp"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const CreateItem400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const CreateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Lookup Thai address by postal code
 */
export const lookupAddressByPostalCodeQueryPostalCodeRegExp = new RegExp("^\\d{5}$");

export const LookupAddressByPostalCodeQueryParams = zod
    .object({
        postal_code: zod
            .string()
            .regex(lookupAddressByPostalCodeQueryPostalCodeRegExp)
            .describe("Thai postal code (5 digits)"),
    })
    .strict();

export const lookupAddressByPostalCode200ResponseDataCityMax = 100;

export const lookupAddressByPostalCode200ResponseDataAddressMax = 255;

export const LookupAddressByPostalCode200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                found: zod.boolean().optional(),
                city: zod.string().max(lookupAddressByPostalCode200ResponseDataCityMax).optional(),
                address: zod.string().max(lookupAddressByPostalCode200ResponseDataAddressMax).optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const LookupAddressByPostalCode422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        errors: zod.object({}).passthrough().optional(),
    })
    .strict();

/**
 * Admin-only helper endpoint. Accepts only email and nickname, generates a temporary password on the server, and returns it once in the response.
 * @summary Create a user account from the admin screen
 */
export const createAdminAccountBodyEmailMax = 255;

export const createAdminAccountBodyNickNameMax = 50;

export const CreateAdminAccountBody = zod
    .object({
        email: zod.string().email().max(createAdminAccountBodyEmailMax),
        nick_name: zod.string().max(createAdminAccountBodyNickNameMax),
    })
    .strict();

export const createAdminAccount201ResponseUserDisplayNameMax = 50;

export const createAdminAccount201ResponseUserFullNameMax = 150;

export const createAdminAccount201ResponseUserFirstNameMax = 100;

export const createAdminAccount201ResponseUserMiddleNameMax = 50;

export const createAdminAccount201ResponseUserLastNameMax = 100;

export const createAdminAccount201ResponseUserNickNameMax = 50;

export const createAdminAccount201ResponseUserEmailMax = 255;

export const createAdminAccount201ResponseUserPreferredPriceRangeMax = 50;

export const createAdminAccount201ResponseUserPrefectureMax = 100;

export const createAdminAccount201ResponseUserAddressMax = 255;

export const createAdminAccount201ResponseUserCityMax = 100;

export const createAdminAccount201ResponseUserZipCodeMax = 10;

export const createAdminAccount201ResponseUserPhoneMax = 20;

export const createAdminAccount201ResponseUserAvatarMax = 255;

export const createAdminAccount201ResponseUserUserNoteMax = 1000;

export const createAdminAccount201ResponseUserSocialInstagramMax = 100;

export const createAdminAccount201ResponseUserSocialFacebookMax = 100;

export const createAdminAccount201ResponseUserSocialXMax = 100;

export const createAdminAccount201ResponseUserSocialTiktokMax = 100;

export const createAdminAccount201ResponseUserSocialYoutubeMax = 100;

export const createAdminAccount201ResponseUserSocialWebsiteMax = 500;

export const createAdminAccount201ResponseGeneratedPasswordMin = 8;
export const createAdminAccount201ResponseGeneratedPasswordMax = 100;

export const CreateAdminAccount201Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        user: zod
            .object({
                user_id: zod.number().optional(),
                display_name: zod
                    .string()
                    .max(createAdminAccount201ResponseUserDisplayNameMax)
                    .optional()
                    .describe("Full display name"),
                full_name: zod
                    .string()
                    .max(createAdminAccount201ResponseUserFullNameMax)
                    .optional()
                    .describe("Full name"),
                first_name: zod
                    .string()
                    .max(createAdminAccount201ResponseUserFirstNameMax)
                    .optional()
                    .describe("First name"),
                middle_name: zod
                    .string()
                    .max(createAdminAccount201ResponseUserMiddleNameMax)
                    .optional()
                    .describe("Middle name (optional)"),
                last_name: zod
                    .string()
                    .max(createAdminAccount201ResponseUserLastNameMax)
                    .optional()
                    .describe("Last name"),
                nick_name: zod
                    .string()
                    .max(createAdminAccount201ResponseUserNickNameMax)
                    .optional()
                    .describe("Nickname or username"),
                email: zod.string().email().max(createAdminAccount201ResponseUserEmailMax).optional(),
                date_of_birth: zod.string().date().nullish().describe("Date of birth in YYYY-MM-DD format"),
                gender: zod
                    .enum(["male", "female", "other", "prefer_not_to_say"])
                    .nullish()
                    .describe("Gender identity"),
                skin_type: zod
                    .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
                    .nullish()
                    .describe("Skin type (preference profile)"),
                skin_concerns: zod.array(zod.string()).optional().describe("Skin concerns (multiple selection)"),
                skin_tone: zod
                    .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                    .nullish()
                    .describe("Skin tone (single select)"),
                hair_type: zod
                    .enum(["straight_coarse", "straight_soft", "wavy_coarse", "wavy_soft", "normal_hair", "not_sure"])
                    .nullish()
                    .describe("Hair type (single select)"),
                hair_scalp_concerns: zod.array(zod.string()).optional().describe("Hair and scalp concerns"),
                beauty_wellness_interests: zod.array(zod.string()).optional().describe("Beauty and wellness interests"),
                lifestyle_environment: zod
                    .array(zod.string())
                    .optional()
                    .describe("Lifestyle and environment selections"),
                makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                preferred_price_range: zod
                    .string()
                    .max(createAdminAccount201ResponseUserPreferredPriceRangeMax)
                    .optional(),
                frequent_category_ids: zod.array(zod.number()).optional().describe("Frequently used category IDs"),
                frequent_brand_ids: zod.array(zod.number()).optional().describe("Frequently used brand IDs"),
                prefecture: zod
                    .string()
                    .max(createAdminAccount201ResponseUserPrefectureMax)
                    .optional()
                    .describe("Prefecture\/province label as stored in user profile"),
                address: zod
                    .string()
                    .max(createAdminAccount201ResponseUserAddressMax)
                    .optional()
                    .describe("Full address (single field)"),
                city: zod.string().max(createAdminAccount201ResponseUserCityMax).optional().describe("City"),
                zip_code: zod
                    .string()
                    .max(createAdminAccount201ResponseUserZipCodeMax)
                    .optional()
                    .describe("Postal code"),
                phone: zod.string().max(createAdminAccount201ResponseUserPhoneMax).optional().describe("Phone number"),
                role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                avatar: zod
                    .string()
                    .max(createAdminAccount201ResponseUserAvatarMax)
                    .optional()
                    .describe("Avatar filename or external URL. Example: user_1_1734567890.jpg"),
                user_status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional(),
                user_note: zod
                    .string()
                    .max(createAdminAccount201ResponseUserUserNoteMax)
                    .optional()
                    .describe("Admin note. For user_status=migrated: the legacy email\/avatar."),
                point: zod.number().optional().describe("User points or score"),
                monthly_rank: zod
                    .number()
                    .min(1)
                    .nullish()
                    .describe("Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)"),
                posts_count: zod.number().nullish().describe("Number of posts created by user (all boards)"),
                review_count: zod
                    .number()
                    .nullish()
                    .describe("Number of review posts created by user (board_id=review)"),
                followers_count: zod.number().optional().describe("Number of followers"),
                followings_count: zod.number().optional().describe("Number of users being followed"),
                followers: zod.array(zod.number()).optional().describe("List of follower user IDs"),
                followings: zod.array(zod.number()).optional().describe("List of following user IDs"),
                favorites: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                favorite_products: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                favorites_count: zod.number().optional().describe("Number of favorite products"),
                social_instagram: zod
                    .string()
                    .max(createAdminAccount201ResponseUserSocialInstagramMax)
                    .optional()
                    .describe("Instagram username"),
                social_facebook: zod
                    .string()
                    .max(createAdminAccount201ResponseUserSocialFacebookMax)
                    .optional()
                    .describe("Facebook username or profile URL"),
                social_x: zod
                    .string()
                    .max(createAdminAccount201ResponseUserSocialXMax)
                    .optional()
                    .describe("X (Twitter) username"),
                social_tiktok: zod
                    .string()
                    .max(createAdminAccount201ResponseUserSocialTiktokMax)
                    .optional()
                    .describe("TikTok username"),
                social_youtube: zod
                    .string()
                    .max(createAdminAccount201ResponseUserSocialYoutubeMax)
                    .optional()
                    .describe("YouTube channel name or URL"),
                social_website: zod
                    .string()
                    .max(createAdminAccount201ResponseUserSocialWebsiteMax)
                    .optional()
                    .describe("Personal or profile website URL"),
                favorite_brands: zod.array(zod.string()).optional().describe("List of favorite brand names"),
                created_by: zod.number().nullish().describe("User ID that created this user record"),
                updated_by: zod.number().nullish().describe("User ID that last updated this user record"),
                recommend_rank: zod.number().min(1).nullish().describe("Recommend ranking rank"),
                created_at: zod.string().datetime({ offset: true }).optional(),
                updated_at: zod.string().datetime({ offset: true }).optional(),
                last_login_at: zod.string().datetime({ offset: true }).optional().describe("Last login timestamp"),
            })
            .strict(),
        generated_password: zod
            .string()
            .min(createAdminAccount201ResponseGeneratedPasswordMin)
            .max(createAdminAccount201ResponseGeneratedPasswordMax)
            .describe("Temporary generated password shown only at account creation time."),
    })
    .strict();

export const CreateAdminAccount401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const CreateAdminAccount403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const CreateAdminAccount409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const CreateAdminAccount422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const CreateAdminAccount500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Get user detail by ID
 */
export const GetItemParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const getItem200ResponseDataItemOneDisplayNameMax = 50;

export const getItem200ResponseDataItemOneFullNameMax = 150;

export const getItem200ResponseDataItemOneFirstNameMax = 100;

export const getItem200ResponseDataItemOneMiddleNameMax = 50;

export const getItem200ResponseDataItemOneLastNameMax = 100;

export const getItem200ResponseDataItemOneNickNameMax = 50;

export const getItem200ResponseDataItemOneEmailMax = 255;

export const getItem200ResponseDataItemOnePreferredPriceRangeMax = 50;

export const getItem200ResponseDataItemOnePrefectureMax = 100;

export const getItem200ResponseDataItemOneAddressMax = 255;

export const getItem200ResponseDataItemOneCityMax = 100;

export const getItem200ResponseDataItemOneZipCodeMax = 10;

export const getItem200ResponseDataItemOnePhoneMax = 20;

export const getItem200ResponseDataItemOneAvatarMax = 255;

export const getItem200ResponseDataItemOneUserNoteMax = 1000;

export const getItem200ResponseDataItemOneSocialInstagramMax = 100;

export const getItem200ResponseDataItemOneSocialFacebookMax = 100;

export const getItem200ResponseDataItemOneSocialXMax = 100;

export const getItem200ResponseDataItemOneSocialTiktokMax = 100;

export const getItem200ResponseDataItemOneSocialYoutubeMax = 100;

export const getItem200ResponseDataItemOneSocialWebsiteMax = 500;

export const getItem200ResponseDataItemTwoFollowersJoinedItemDisplayNameMax = 50;

export const getItem200ResponseDataItemTwoFollowersJoinedItemNickNameMax = 50;

export const getItem200ResponseDataItemTwoFollowersJoinedItemNameMax = 100;

export const getItem200ResponseDataItemTwoFollowersJoinedItemFullNameMax = 150;

export const getItem200ResponseDataItemTwoFollowersJoinedItemAvatarMax = 255;

export const getItem200ResponseDataItemTwoFollowingsJoinedItemDisplayNameMax = 50;

export const getItem200ResponseDataItemTwoFollowingsJoinedItemNickNameMax = 50;

export const getItem200ResponseDataItemTwoFollowingsJoinedItemNameMax = 100;

export const getItem200ResponseDataItemTwoFollowingsJoinedItemFullNameMax = 150;

export const getItem200ResponseDataItemTwoFollowingsJoinedItemAvatarMax = 255;

export const getItem200ResponseDataItemTwoFavoritesJoinedItemProductNameMax = 255;

export const getItem200ResponseDataItemTwoFavoritesJoinedItemPriceUnitMax = 10;

export const GetItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                item: zod
                    .object({
                        user_id: zod.number().optional(),
                        display_name: zod
                            .string()
                            .max(getItem200ResponseDataItemOneDisplayNameMax)
                            .optional()
                            .describe("Full display name"),
                        full_name: zod
                            .string()
                            .max(getItem200ResponseDataItemOneFullNameMax)
                            .optional()
                            .describe("Full name"),
                        first_name: zod
                            .string()
                            .max(getItem200ResponseDataItemOneFirstNameMax)
                            .optional()
                            .describe("First name"),
                        middle_name: zod
                            .string()
                            .max(getItem200ResponseDataItemOneMiddleNameMax)
                            .optional()
                            .describe("Middle name (optional)"),
                        last_name: zod
                            .string()
                            .max(getItem200ResponseDataItemOneLastNameMax)
                            .optional()
                            .describe("Last name"),
                        nick_name: zod
                            .string()
                            .max(getItem200ResponseDataItemOneNickNameMax)
                            .optional()
                            .describe("Nickname or username"),
                        email: zod.string().email().max(getItem200ResponseDataItemOneEmailMax).optional(),
                        date_of_birth: zod.string().date().nullish().describe("Date of birth in YYYY-MM-DD format"),
                        gender: zod
                            .enum(["male", "female", "other", "prefer_not_to_say"])
                            .nullish()
                            .describe("Gender identity"),
                        skin_type: zod
                            .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
                            .nullish()
                            .describe("Skin type (preference profile)"),
                        skin_concerns: zod
                            .array(zod.string())
                            .optional()
                            .describe("Skin concerns (multiple selection)"),
                        skin_tone: zod
                            .enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"])
                            .nullish()
                            .describe("Skin tone (single select)"),
                        hair_type: zod
                            .enum([
                                "straight_coarse",
                                "straight_soft",
                                "wavy_coarse",
                                "wavy_soft",
                                "normal_hair",
                                "not_sure",
                            ])
                            .nullish()
                            .describe("Hair type (single select)"),
                        hair_scalp_concerns: zod.array(zod.string()).optional().describe("Hair and scalp concerns"),
                        beauty_wellness_interests: zod
                            .array(zod.string())
                            .optional()
                            .describe("Beauty and wellness interests"),
                        lifestyle_environment: zod
                            .array(zod.string())
                            .optional()
                            .describe("Lifestyle and environment selections"),
                        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).nullish(),
                        preferred_price_range: zod
                            .string()
                            .max(getItem200ResponseDataItemOnePreferredPriceRangeMax)
                            .optional(),
                        frequent_category_ids: zod
                            .array(zod.number())
                            .optional()
                            .describe("Frequently used category IDs"),
                        frequent_brand_ids: zod.array(zod.number()).optional().describe("Frequently used brand IDs"),
                        prefecture: zod
                            .string()
                            .max(getItem200ResponseDataItemOnePrefectureMax)
                            .optional()
                            .describe("Prefecture\/province label as stored in user profile"),
                        address: zod
                            .string()
                            .max(getItem200ResponseDataItemOneAddressMax)
                            .optional()
                            .describe("Full address (single field)"),
                        city: zod.string().max(getItem200ResponseDataItemOneCityMax).optional().describe("City"),
                        zip_code: zod
                            .string()
                            .max(getItem200ResponseDataItemOneZipCodeMax)
                            .optional()
                            .describe("Postal code"),
                        phone: zod
                            .string()
                            .max(getItem200ResponseDataItemOnePhoneMax)
                            .optional()
                            .describe("Phone number"),
                        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
                        avatar: zod
                            .string()
                            .max(getItem200ResponseDataItemOneAvatarMax)
                            .optional()
                            .describe("Avatar filename or external URL. Example: user_1_1734567890.jpg"),
                        user_status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional(),
                        user_note: zod
                            .string()
                            .max(getItem200ResponseDataItemOneUserNoteMax)
                            .optional()
                            .describe("Admin note. For user_status=migrated: the legacy email\/avatar."),
                        point: zod.number().optional().describe("User points or score"),
                        monthly_rank: zod
                            .number()
                            .min(1)
                            .nullish()
                            .describe(
                                "Monthly ranking rank (materialized; previous month based on real date) (ISS:04-048)",
                            ),
                        posts_count: zod.number().nullish().describe("Number of posts created by user (all boards)"),
                        review_count: zod
                            .number()
                            .nullish()
                            .describe("Number of review posts created by user (board_id=review)"),
                        followers_count: zod.number().optional().describe("Number of followers"),
                        followings_count: zod.number().optional().describe("Number of users being followed"),
                        followers: zod.array(zod.number()).optional().describe("List of follower user IDs"),
                        followings: zod.array(zod.number()).optional().describe("List of following user IDs"),
                        favorites: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                        favorite_products: zod.array(zod.number()).optional().describe("List of favorite product IDs"),
                        favorites_count: zod.number().optional().describe("Number of favorite products"),
                        social_instagram: zod
                            .string()
                            .max(getItem200ResponseDataItemOneSocialInstagramMax)
                            .optional()
                            .describe("Instagram username"),
                        social_facebook: zod
                            .string()
                            .max(getItem200ResponseDataItemOneSocialFacebookMax)
                            .optional()
                            .describe("Facebook username or profile URL"),
                        social_x: zod
                            .string()
                            .max(getItem200ResponseDataItemOneSocialXMax)
                            .optional()
                            .describe("X (Twitter) username"),
                        social_tiktok: zod
                            .string()
                            .max(getItem200ResponseDataItemOneSocialTiktokMax)
                            .optional()
                            .describe("TikTok username"),
                        social_youtube: zod
                            .string()
                            .max(getItem200ResponseDataItemOneSocialYoutubeMax)
                            .optional()
                            .describe("YouTube channel name or URL"),
                        social_website: zod
                            .string()
                            .max(getItem200ResponseDataItemOneSocialWebsiteMax)
                            .optional()
                            .describe("Personal or profile website URL"),
                        favorite_brands: zod.array(zod.string()).optional().describe("List of favorite brand names"),
                        created_by: zod.number().nullish().describe("User ID that created this user record"),
                        updated_by: zod.number().nullish().describe("User ID that last updated this user record"),
                        recommend_rank: zod.number().min(1).nullish().describe("Recommend ranking rank"),
                        created_at: zod.string().datetime({ offset: true }).optional(),
                        updated_at: zod.string().datetime({ offset: true }).optional(),
                        last_login_at: zod
                            .string()
                            .datetime({ offset: true })
                            .optional()
                            .describe("Last login timestamp"),
                        followers_joined: zod
                            .array(
                                zod
                                    .object({
                                        user_id: zod.number().optional(),
                                        display_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowersJoinedItemDisplayNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowersJoinedItemNickNameMax)
                                            .optional(),
                                        name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowersJoinedItemNameMax)
                                            .optional(),
                                        full_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowersJoinedItemFullNameMax)
                                            .optional(),
                                        avatar: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowersJoinedItemAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        gender: zod
                                            .enum(["male", "female", "other", "prefer_not_to_say"])
                                            .nullish()
                                            .describe("Gender identity"),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish()
                                            .describe("Skin type (preference profile)"),
                                        skin_concerns: zod
                                            .array(zod.string())
                                            .nullish()
                                            .describe("Skin concerns (multiple selection)"),
                                        date_of_birth: zod
                                            .string()
                                            .date()
                                            .nullish()
                                            .describe("Date of birth in YYYY-MM-DD format"),
                                        role: zod
                                            .enum(["admin", "editor", "moderator", "expert", "user"])
                                            .optional()
                                            .describe("User role"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("List of follower user objects (joined data)"),
                        followings_joined: zod
                            .array(
                                zod
                                    .object({
                                        user_id: zod.number().optional(),
                                        display_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowingsJoinedItemDisplayNameMax)
                                            .optional(),
                                        nick_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowingsJoinedItemNickNameMax)
                                            .optional(),
                                        name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowingsJoinedItemNameMax)
                                            .optional(),
                                        full_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowingsJoinedItemFullNameMax)
                                            .optional(),
                                        avatar: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFollowingsJoinedItemAvatarMax)
                                            .optional(),
                                        posts_count: zod.number().nullish(),
                                        followers_count: zod.number().optional(),
                                        gender: zod
                                            .enum(["male", "female", "other", "prefer_not_to_say"])
                                            .nullish()
                                            .describe("Gender identity"),
                                        skin_type: zod
                                            .enum([
                                                "normal",
                                                "oily",
                                                "dry",
                                                "combination",
                                                "sensitive",
                                                "dehydrated_oily",
                                                "not_sure",
                                            ])
                                            .nullish()
                                            .describe("Skin type (preference profile)"),
                                        skin_concerns: zod
                                            .array(zod.string())
                                            .nullish()
                                            .describe("Skin concerns (multiple selection)"),
                                        date_of_birth: zod
                                            .string()
                                            .date()
                                            .nullish()
                                            .describe("Date of birth in YYYY-MM-DD format"),
                                        role: zod
                                            .enum(["admin", "editor", "moderator", "expert", "user"])
                                            .optional()
                                            .describe("User role"),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("List of following user objects (joined data)"),
                        favorites_joined: zod
                            .array(
                                zod
                                    .object({
                                        product_id: zod.number().optional(),
                                        product_name: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFavoritesJoinedItemProductNameMax)
                                            .optional(),
                                        image: zod.string().optional(),
                                        average_rating: zod.number().nullish(),
                                        brand_id: zod.number().nullish(),
                                        price: zod.number().nullish(),
                                        price_unit: zod
                                            .string()
                                            .max(getItem200ResponseDataItemTwoFavoritesJoinedItemPriceUnitMax)
                                            .optional(),
                                        review_count: zod.number().nullish(),
                                    })
                                    .strict(),
                            )
                            .optional()
                            .describe("List of favorite product objects (joined data)"),
                    })
                    .strict()
                    .optional()
                    .describe("User object with joined followers, followings, and favorites data"),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetItem400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(403), zod.literal(404), zod.literal(422)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(403), zod.literal(404), zod.literal(422)])
            .describe("HTTP status code"),
    })
    .strict();

export const GetItem404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([zod.literal(400), zod.literal(403), zod.literal(404), zod.literal(422)])
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Update user profile information
 */
export const UpdateItemParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const updateItemBodyFullNameMax = 150;

export const updateItemBodyFirstNameMax = 100;

export const updateItemBodyMiddleNameMax = 50;

export const updateItemBodyLastNameMax = 100;

export const updateItemBodyNickNameMax = 50;

export const updateItemBodyEmailMax = 255;

export const updateItemBodyPhoneMax = 20;

export const updateItemBodyPreferredPriceRangeMax = 50;

export const updateItemBodyPrefectureMax = 100;

export const updateItemBodyCityMax = 100;

export const updateItemBodyZipCodeMax = 10;

export const updateItemBodyZipCodeRegExp = new RegExp("^\\d{5}$");
export const updateItemBodyAddressMax = 255;

export const updateItemBodySocialInstagramMax = 100;

export const updateItemBodySocialFacebookMax = 100;

export const updateItemBodySocialXMax = 100;

export const updateItemBodySocialTiktokMax = 100;

export const updateItemBodySocialYoutubeMax = 100;

export const updateItemBodySocialWebsiteMax = 500;

export const updateItemBodyUserNoteMax = 1000;

export const UpdateItemBody = zod
    .object({
        full_name: zod
            .string()
            .max(updateItemBodyFullNameMax)
            .optional()
            .describe("Full name (generated from first\/middle\/last on UI)"),
        first_name: zod.string().max(updateItemBodyFirstNameMax).optional(),
        middle_name: zod.string().max(updateItemBodyMiddleNameMax).optional(),
        last_name: zod.string().max(updateItemBodyLastNameMax).optional(),
        nick_name: zod.string().max(updateItemBodyNickNameMax).optional(),
        email: zod.string().email().max(updateItemBodyEmailMax).optional(),
        phone: zod.string().max(updateItemBodyPhoneMax).optional(),
        date_of_birth: zod.string().date().nullish(),
        gender: zod.enum(["male", "female", "other", "prefer_not_to_say"]).optional(),
        skin_type: zod
            .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
            .optional(),
        skin_concerns: zod.string().nullish(),
        skin_tone: zod.enum(["very_fair", "fair", "medium", "tan", "deep", "not_sure"]).optional(),
        hair_type: zod
            .enum(["straight_coarse", "straight_soft", "wavy_coarse", "wavy_soft", "normal_hair", "not_sure"])
            .optional(),
        hair_scalp_concerns: zod.string().nullish(),
        beauty_wellness_interests: zod.string().nullish(),
        lifestyle_environment: zod.string().nullish(),
        makeup_frequency: zod.enum(["every_day", "occasionally", "rarely"]).optional(),
        preferred_price_range: zod.string().max(updateItemBodyPreferredPriceRangeMax).optional(),
        frequent_category_ids: zod.string().nullish(),
        frequent_brand_ids: zod.string().nullish(),
        prefecture: zod
            .string()
            .max(updateItemBodyPrefectureMax)
            .optional()
            .describe("Prefecture\/province label as stored in user profile"),
        city: zod.string().max(updateItemBodyCityMax).optional(),
        zip_code: zod.string().max(updateItemBodyZipCodeMax).regex(updateItemBodyZipCodeRegExp).optional(),
        address: zod.string().max(updateItemBodyAddressMax).optional(),
        social_instagram: zod.string().max(updateItemBodySocialInstagramMax).optional(),
        social_facebook: zod.string().max(updateItemBodySocialFacebookMax).optional(),
        social_x: zod.string().max(updateItemBodySocialXMax).optional(),
        social_tiktok: zod.string().max(updateItemBodySocialTiktokMax).optional(),
        social_youtube: zod.string().max(updateItemBodySocialYoutubeMax).optional(),
        social_website: zod.string().url().max(updateItemBodySocialWebsiteMax).optional(),
        role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional(),
        user_status: zod.enum(["active", "inactive", "dummy", "migrated"]).optional(),
        user_note: zod
            .string()
            .max(updateItemBodyUserNoteMax)
            .optional()
            .describe("Admin note (admin\/editor editable)."),
    })
    .strict();

export const UpdateItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        user_id: zod.number().optional(),
    })
    .strict();

export const UpdateItem400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const UpdateItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const UpdateItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

/**
 * @summary Delete user
 */
export const DeleteItemParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const DeleteItem200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

export const DeleteItem403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const DeleteItem422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

export const DeleteItem500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().describe("Error message"),
        errors: zod.record(zod.string(), zod.unknown()).optional().describe("Detailed error information"),
        status_code: zod
            .union([
                zod.literal(400),
                zod.literal(401),
                zod.literal(403),
                zod.literal(404),
                zod.literal(409),
                zod.literal(422),
                zod.literal(500),
            ])
            .optional()
            .describe("HTTP status code"),
    })
    .strict();

/**
 * Used by the rank selection popup to disable already-used ranks (admin/editor only).
 * @summary Get recommend meta (used ranks, current rank)
 */
export const GetUserRecommendMetaParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const getUserRecommendMeta200ResponseDataCurrentRankMax = 15;

export const getUserRecommendMeta200ResponseDataUsedRanksItemMax = 15;

export const GetUserRecommendMeta200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number(),
                max_rank: zod.number(),
                current_rank: zod.number().min(1).max(getUserRecommendMeta200ResponseDataCurrentRankMax).nullable(),
                used_ranks: zod.array(zod.number().min(1).max(getUserRecommendMeta200ResponseDataUsedRanksItemMax)),
            })
            .strict()
            .optional(),
    })
    .strict();

export const GetUserRecommendMeta401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const GetUserRecommendMeta403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const GetUserRecommendMeta404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const GetUserRecommendMeta500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * Set or update recommend rank. Rank can be null (admin/editor only).
 * @summary Set/update recommend rank
 */
export const UpsertUserRecommendParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const upsertUserRecommendBodyRankMax = 15;

export const UpsertUserRecommendBody = zod
    .object({
        rank: zod
            .number()
            .min(1)
            .max(upsertUserRecommendBodyRankMax)
            .describe("Recommend rank (1..15) or null to unset"),
    })
    .strict();

export const upsertUserRecommend200ResponseDataRankMax = 15;

export const UpsertUserRecommend200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number(),
                rank: zod.number().min(1).max(upsertUserRecommend200ResponseDataRankMax),
            })
            .strict()
            .optional(),
    })
    .strict();

export const UpsertUserRecommend401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertUserRecommend403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertUserRecommend404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertUserRecommend409Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertUserRecommend422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const UpsertUserRecommend500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * Remove recommend entry for the user (admin/editor only).
 * @summary Unset recommend
 */
export const RemoveUserRecommendParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const RemoveUserRecommend200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number(),
            })
            .strict()
            .optional(),
    })
    .strict();

export const RemoveUserRecommend401Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveUserRecommend403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveUserRecommend404Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

export const RemoveUserRecommend500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string(),
        errors: zod.record(zod.string(), zod.unknown()).optional(),
        status_code: zod.union([
            zod.literal(400),
            zod.literal(401),
            zod.literal(403),
            zod.literal(404),
            zod.literal(409),
            zod.literal(422),
            zod.literal(500),
        ]),
    })
    .strict();

/**
 * @summary Upload user avatar image
 */
export const UploadAvatarBody = zod
    .object({
        avatar: zod
            .instanceof(File)
            .describe(
                "Avatar image file (JPG, PNG, GIF, WEBP, max 10MB upload; automatically compressed to 2MB after EXIF-aware rotation)",
            ),
    })
    .strict();

export const UploadAvatar200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        avatar_url: zod
            .string()
            .optional()
            .describe("Public URL\/path to the uploaded avatar (computed; do not store this in Users.json)."),
        filename: zod.string().optional().describe("Avatar filename or external URL"),
        message: zod.string().optional(),
    })
    .strict();

export const UploadAvatar400Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

export const UploadAvatar403Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

export const UploadAvatar422Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

export const UploadAvatar500Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
    })
    .strict();

/**
 * @summary Follow a user
 */
export const FollowUserBody = zod
    .object({
        user_id: zod.number().describe("Target user ID to follow"),
    })
    .strict();

export const FollowUser200Response = zod
    .object({
        success: zod
            .union([zod.union([zod.literal(0), zod.literal(1)]), zod.union([zod.literal(0), zod.literal(1)])])
            .optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number().optional(),
                target_user_id: zod.number().optional(),
                followings_count: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

/**
 * @summary Unfollow a user
 */
export const UnfollowUserParams = zod
    .object({
        user_id: zod.number().describe("Target user ID to unfollow"),
    })
    .strict();

export const UnfollowUser200Response = zod
    .object({
        success: zod
            .union([zod.union([zod.literal(0), zod.literal(1)]), zod.union([zod.literal(0), zod.literal(1)])])
            .optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number().optional(),
                target_user_id: zod.number().optional(),
                followings_count: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

/**
 * @summary Get following users list
 */
export const GetFollowingsParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const getFollowingsQueryPageDefault = 1;

export const getFollowingsQueryPerPageDefault = 20;
export const getFollowingsQueryPerPageMax = 100;

export const GetFollowingsQueryParams = zod
    .object({
        page: zod.number().min(1).default(getFollowingsQueryPageDefault).describe("Page number"),
        per_page: zod
            .number()
            .min(1)
            .max(getFollowingsQueryPerPageMax)
            .default(getFollowingsQueryPerPageDefault)
            .describe("Items per page"),
    })
    .strict();

export const getFollowings200ResponseDataItemDisplayNameMax = 50;

export const getFollowings200ResponseDataItemNickNameMax = 50;

export const getFollowings200ResponseDataItemNameMax = 100;

export const getFollowings200ResponseDataItemFullNameMax = 150;

export const getFollowings200ResponseDataItemAvatarMax = 255;

export const GetFollowings200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod.array(
            zod
                .object({
                    user_id: zod.number().optional(),
                    display_name: zod.string().max(getFollowings200ResponseDataItemDisplayNameMax).optional(),
                    nick_name: zod.string().max(getFollowings200ResponseDataItemNickNameMax).optional(),
                    name: zod.string().max(getFollowings200ResponseDataItemNameMax).optional(),
                    full_name: zod.string().max(getFollowings200ResponseDataItemFullNameMax).optional(),
                    avatar: zod.string().max(getFollowings200ResponseDataItemAvatarMax).optional(),
                    review_count: zod.number().nullish(),
                    gender: zod
                        .enum(["male", "female", "other", "prefer_not_to_say"])
                        .nullish()
                        .describe("Gender identity"),
                    skin_type: zod
                        .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
                        .nullish()
                        .describe("Skin type (preference profile)"),
                    skin_concerns: zod.array(zod.string()).nullish().describe("Skin concerns (multiple selection)"),
                    date_of_birth: zod
                        .string()
                        .date()
                        .nullish()
                        .describe("Date of birth in YYYY-MM-DD format (may be omitted\/nullable for privacy)"),
                    role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional().describe("User role"),
                    posts_count: zod.number().nullish(),
                    followers_count: zod.number().optional(),
                    monthly_rank: zod.number().nullish(),
                    recommend_rank: zod.number().nullish(),
                    rank: zod.number().nullish(),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

/**
 * @summary Get followers list
 */
export const GetFollowersParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const getFollowersQueryPageDefault = 1;

export const getFollowersQueryPerPageDefault = 20;
export const getFollowersQueryPerPageMax = 100;

export const GetFollowersQueryParams = zod
    .object({
        page: zod.number().min(1).default(getFollowersQueryPageDefault).describe("Page number"),
        per_page: zod
            .number()
            .min(1)
            .max(getFollowersQueryPerPageMax)
            .default(getFollowersQueryPerPageDefault)
            .describe("Items per page"),
    })
    .strict();

export const getFollowers200ResponseDataItemDisplayNameMax = 50;

export const getFollowers200ResponseDataItemNickNameMax = 50;

export const getFollowers200ResponseDataItemNameMax = 100;

export const getFollowers200ResponseDataItemFullNameMax = 150;

export const getFollowers200ResponseDataItemAvatarMax = 255;

export const GetFollowers200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod.array(
            zod
                .object({
                    user_id: zod.number().optional(),
                    display_name: zod.string().max(getFollowers200ResponseDataItemDisplayNameMax).optional(),
                    nick_name: zod.string().max(getFollowers200ResponseDataItemNickNameMax).optional(),
                    name: zod.string().max(getFollowers200ResponseDataItemNameMax).optional(),
                    full_name: zod.string().max(getFollowers200ResponseDataItemFullNameMax).optional(),
                    avatar: zod.string().max(getFollowers200ResponseDataItemAvatarMax).optional(),
                    review_count: zod.number().nullish(),
                    gender: zod
                        .enum(["male", "female", "other", "prefer_not_to_say"])
                        .nullish()
                        .describe("Gender identity"),
                    skin_type: zod
                        .enum(["normal", "oily", "dry", "combination", "sensitive", "dehydrated_oily", "not_sure"])
                        .nullish()
                        .describe("Skin type (preference profile)"),
                    skin_concerns: zod.array(zod.string()).nullish().describe("Skin concerns (multiple selection)"),
                    date_of_birth: zod
                        .string()
                        .date()
                        .nullish()
                        .describe("Date of birth in YYYY-MM-DD format (may be omitted\/nullable for privacy)"),
                    role: zod.enum(["admin", "editor", "moderator", "expert", "user"]).optional().describe("User role"),
                    posts_count: zod.number().nullish(),
                    followers_count: zod.number().optional(),
                    monthly_rank: zod.number().nullish(),
                    recommend_rank: zod.number().nullish(),
                    rank: zod.number().nullish(),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

/**
 * @summary Get favorite products list
 */
export const GetFavoritesParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const getFavoritesQueryPageDefault = 1;

export const getFavoritesQueryPerPageDefault = 20;
export const getFavoritesQueryPerPageMax = 100;

export const GetFavoritesQueryParams = zod
    .object({
        page: zod.number().min(1).default(getFavoritesQueryPageDefault).describe("Page number"),
        per_page: zod
            .number()
            .min(1)
            .max(getFavoritesQueryPerPageMax)
            .default(getFavoritesQueryPerPageDefault)
            .describe("Items per page"),
    })
    .strict();

export const getFavorites200ResponseDataItemBrandNameMax = 100;

export const getFavorites200ResponseDataItemProductNameMax = 255;

export const getFavorites200ResponseDataItemPriceUnitMax = 10;

export const getFavorites200ResponseDataItemUnitMax = 100;

export const getFavorites200ResponseDataItemCategoryNameMax = 100;

export const getFavorites200ResponseDataItemParentCategoryNameMax = 100;

export const GetFavorites200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod.array(
            zod
                .object({
                    product_id: zod.number().optional(),
                    brand_id: zod.number().nullish(),
                    brand_name: zod.string().max(getFavorites200ResponseDataItemBrandNameMax).optional(),
                    product_name: zod.string().max(getFavorites200ResponseDataItemProductNameMax).optional(),
                    image: zod.string().optional(),
                    price: zod.number().nullish(),
                    price_unit: zod.string().max(getFavorites200ResponseDataItemPriceUnitMax).optional(),
                    unit: zod.string().max(getFavorites200ResponseDataItemUnitMax).optional(),
                    category_id: zod.number().nullish(),
                    category_name: zod.string().max(getFavorites200ResponseDataItemCategoryNameMax).optional(),
                    parent_category_id: zod.number().nullish(),
                    parent_category_name: zod
                        .string()
                        .max(getFavorites200ResponseDataItemParentCategoryNameMax)
                        .optional(),
                    average_rating: zod.number().nullish(),
                    review_count: zod.number().nullish(),
                    recommend_rank: zod.number().nullish(),
                    category: zod.record(zod.string(), zod.unknown()).optional(),
                    brand: zod.record(zod.string(), zod.unknown()).optional(),
                    price_text: zod.string().optional(),
                })
                .strict(),
        ),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

/**
 * @summary Get latest review posts by user for relationship lists
 */
export const GetUserPostsParams = zod
    .object({
        user_id: zod.number().describe("User ID"),
    })
    .strict();

export const getUserPostsQueryPageDefault = 1;

export const getUserPostsQueryPerPageDefault = 20;
export const getUserPostsQueryPerPageMax = 100;

export const GetUserPostsQueryParams = zod
    .object({
        page: zod.number().min(1).default(getUserPostsQueryPageDefault).describe("Page number"),
        per_page: zod
            .number()
            .min(1)
            .max(getUserPostsQueryPerPageMax)
            .default(getUserPostsQueryPerPageDefault)
            .describe("Items per page"),
    })
    .strict();

export const getUserPosts200ResponseDataItemBrandNameMax = 100;

export const getUserPosts200ResponseDataItemProductNameMax = 255;

export const getUserPosts200ResponseDataItemCategoryNameMax = 100;

export const getUserPosts200ResponseDataItemParentCategoryNameMax = 100;

export const GetUserPosts200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]),
        message: zod.string().optional(),
        data: zod
            .array(
                zod
                    .object({
                        product_id: zod.number().optional(),
                        brand_id: zod.number().nullish(),
                        brand_name: zod.string().max(getUserPosts200ResponseDataItemBrandNameMax).optional(),
                        product_name: zod.string().max(getUserPosts200ResponseDataItemProductNameMax).optional(),
                        image: zod.string().optional(),
                        category_id: zod.number().nullish(),
                        category_name: zod.string().max(getUserPosts200ResponseDataItemCategoryNameMax).optional(),
                        parent_category_id: zod.number().nullish(),
                        parent_category_name: zod
                            .string()
                            .max(getUserPosts200ResponseDataItemParentCategoryNameMax)
                            .optional(),
                        average_rating: zod.number().nullish(),
                        review_count: zod.number().nullish(),
                    })
                    .strict()
                    .describe("Product-like cards derived from the user's latest review posts."),
            )
            .describe(
                "Relationship-list payload. This endpoint does not provide SSR board-card markup or post-detail-hydrated page data.",
            ),
        pagination: zod
            .object({
                current_page: zod.number().optional(),
                total: zod.number().optional(),
                per_page: zod.number().optional(),
                last_page: zod.number().optional(),
            })
            .strict(),
    })
    .strict();

/**
 * @summary Add product to favorites
 */
export const AddFavoriteBody = zod
    .object({
        product_id: zod.number().describe("Product ID to add to favorites"),
    })
    .strict();

export const AddFavorite200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number().optional(),
                product_id: zod.number().optional(),
                favorites_count: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();

/**
 * @summary Remove product from favorites
 */
export const RemoveFavoriteParams = zod
    .object({
        product_id: zod.number().describe("Product ID to remove from favorites"),
    })
    .strict();

export const RemoveFavorite200Response = zod
    .object({
        success: zod.union([zod.literal(0), zod.literal(1)]).optional(),
        message: zod.string().optional(),
        data: zod
            .object({
                user_id: zod.number().optional(),
                product_id: zod.number().optional(),
                favorites_count: zod.number().optional(),
            })
            .strict()
            .optional(),
    })
    .strict();
